import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { ContextualAlert, Link } from '@paypalcorp/pp-react';
import { fetchFormElementsNoIntent, emailIntentSelected } from '../actions/action-email-no-intent';
import { selectTopicResult } from '../actions/action-select-topic';
import { trackLink, trackPage } from '../../lib/analytics-helper';
import TopicSelection from '../components/TopicSelection';
import EmailForm from './EmailForm';
import PrivacyEmailForm from './PrivacyEmailForm';
import i18n from '../../lib/reacti18n';
import { TOPICTREE } from '../constants/PropTypesShapes';
import Page from '../../lib/page';
import { updateUserSelection } from '../actions/action-update-user-selection';
import { isPUIIntentEnabled } from '../../lib/puiTopicHelper';
import { isPrivacyWebFormEnabledInRC } from '../../lib/globalHelper';
import { kanaCodes, urlConstants } from '../../common/commonConstants';
import { getLastPathVariable } from '../../lib/location-helper';
import AupViolationEmailForm from './AupViolationEmailForm';

const email = {
  header: i18n.message('smarthelp/emailUs.emailUs.header'),
  instruction: i18n.message('smarthelp/emailUs.emailUs.instruction'),
  placeholder1: i18n.message('smarthelp/emailUs.emailUs.placeholder1'),
  placeholder2: i18n.message('smarthelp/emailUs.emailUs.placeholder2'),
  error: i18n.message('smarthelp/Error.error.email.newInvalid', { helpCenterUrl: urlConstants.HELP_CENTER_URL }),
  contactUs: i18n.message('smarthelp/index.browser_title'),
  contentDidNotLoadLabel: i18n.message('smarthelp/app.errorMessage.label'),
  tryAgainLabel: i18n.message('smarthelp/app.errorMessage.subLabel'),
};

export const LOAD_CONTENT_MAX_RETRIES = 2;

class EmailNoIntent extends Component {
  static renderError() {
    return (
      <div className="error-email-no-intent">
        <div className="vx_icon vx_icon-large vx_icon-critical-large test" />
        <div className="error-message-email-no-intent">
          {Page.getHTMLElement({ message: email.error, useHTML: true })}
        </div>
      </div>
    );
  }

  // change email form header to contact us for ppgf and ipinfringement
  static getEmailFormHeader() {
    const pageName = getLastPathVariable(window.location);
    let header = email.header;
    if (pageName && (pageName === 'ppgf' || pageName === 'ipinfringement')) {
      header = email.contactUs;
    }
    return header;
  }

  constructor(props) {
    super(props);
    this.state = {
      topicSelections: props.topicTree,
      value: [email.placeholder1, email.placeholder2, email.placeholder2, email.placeholder2],
      label: [email.placeholder1, email.placeholder2, email.placeholder2, email.placeholder2],
      isFirstTime: true,
    };
    this.onTopicSelection = this.onTopicSelection.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (this.state.isFirstTime && nextProps.topicSelection) {
      this.setState({
        topicSelections: nextProps.topicTree,
        isFirstTime: false,
      });
    }
  }

  componentDidUpdate(prevProps) {
    // fpti for email form load error
    if (this.props.error && this.props.error !== prevProps.error) {
      const pageName = getLastPathVariable(window.location);
      trackPage({ id: `${pageName}WebformLoadError`, link: `smarthelp-${pageName}-webform-load-error` });
    }

    // fpti for Try Again error message shown
    if (this.props.retryCount > 0 && this.props.retryCount !== prevProps.retryCount) {
      const pageName = getLastPathVariable(window.location);
      trackPage({ id: `${pageName}ErrorMessageShown`, link: `email-no-intent-${pageName}-error-message-shown` });
    }
  }

  onTopicSelection({ topicRefId, topicId, topicName, topicObj, level }) {
    trackLink({ id: 'emailByPassPage', link: `smarthelp-email-select|L${level + 1}|${topicRefId}` });
    // Set dropdown value
    const value = this.state.value.map((eachValue, index) => {
      if (index > level) {
        return email.placeholder2;
      }
      if (index === level) {
        return topicRefId;
      }
      return eachValue;
    });
    this.setState({
      value,
    });
    // set label to empty to hide it
    const label = this.state.label.map((eachValue, index) => {
      if (index > level) {
        return email.placeholder2;
      }
      if (index === level) {
        return '';
      }
      return eachValue;
    });
    this.setState({
      label,
    });
    this.props.emailIntentSelected(topicName);

    // Set local state for current level Topic tree selection
    const updatedSelection = this.state.topicSelections.slice(0, level + 1);
    updatedSelection.push(topicObj);
    this.setState({
      topicSelections: updatedSelection,
    });

    // check if its a leafnode, then fetch email form and trigger select topic result event
    if (topicObj && topicObj.leaf_node) {
      const intentCode = topicObj.intent_code;
      const customerTreatment = topicObj.customer_intent;
      const internalTreatment = topicObj.internal_treatment;
      this.props.selectTopicResult({
        topicId,
        topicName,
        topicRefId,
        intentCode,
        customerTreatment,
        internalTreatment,
      });
      this.props.fetchFormElementsNoIntent(topicId);
    }
  }

  tryAgainMethod = () => {
    this.props.fetchFormElementsNoIntent(this.props.fieldPrefix);
    const pageName = getLastPathVariable(window.location);
    trackLink({ id: `${pageName}LinkTryAgainClick`, link: `email-no-intent-${pageName}-try-again-link-clicked` });
  };

  // eslint-disable-next-line react/no-unused-class-component-methods
  renderDropDown(topic, level) {
    let topicSelection = null;
    if (topic && topic.sub_topics) {
      const topicObject = topic.sub_topics.map((eachTopic) => {
        const topicOptions = {
          topicRefId: eachTopic.ref_id,
          topicId: eachTopic.topic_id,
          topicName: eachTopic.topic_name,
          topicObj: eachTopic,
          level,
        };
        return topicOptions;
      });

      const options = topicObject.map((eachTopic) => ({
        label: eachTopic.topicName,
        value: eachTopic.topicRefId,
      }));

      topicSelection = (
        <TopicSelection
          options={options}
          topics={topicObject}
          level={level}
          onChange={this.onTopicSelection}
          label={this.state.label[level]}
          value={this.state.value[level]}
          placeholder={this.state.value[level]}
        />
      );
    }
    return topicSelection;
  }

  /**
   *  Show the try again link for email no intent case. User can retry to load the contact content.
   *  Show the Try Again link with error message 2 times and afterwards show just the error message without Try Again link
   * */
  renderTryAgainLink() {
    if (this.props.isLogoutForm) {
      return null;
    }

    if (this.props.retryCount > 0) {
      return (
        <div className="sh-error" data-testid="sh-email-no-intent-error-message-container">
          <ContextualAlert type="error" data-testid="sh-email-no-intent-error-message">
            <div data-testid="sh-email-no-intent-error-message-text">{email.contentDidNotLoadLabel}</div>
          </ContextualAlert>
          <div>
            {this.props.retryCount <= LOAD_CONTENT_MAX_RETRIES && (
              <Link onClick={this.tryAgainMethod} data-testid="sh-email-no-intent-error-message-try-again-link">
                {email.tryAgainLabel}
              </Link>
            )}
          </div>
        </div>
      );
    }
    return null;
  }

  renderEmailHeader() {
    const { kanaCode } = this.props;

    // For PAYPUI001 Tcode do not render email header on the top, it will bee below the page information text
    if (!kanaCode || isPUIIntentEnabled(kanaCode)) {
      return <p />;
    }
    return <p className="email-no-intent-header">{EmailNoIntent.getEmailFormHeader()}</p>;
  }

  render() {
    const { error, display, kanaCode, isIdiLoading, isIdiServiceLoaded, topicName } = this.props;

    if (error) {
      return EmailNoIntent.renderError();
    }
    if (display) {
      // if the request is from Pay upon invoice trigger IDI call to check for chat eligibility
      // Only after getting the kanaCode check for pui topic validation
      if (
        kanaCode &&
        (isPUIIntentEnabled(kanaCode) || isPrivacyWebFormEnabledInRC(kanaCode)) &&
        !isIdiLoading &&
        !isIdiServiceLoaded
      ) {
        this.props.updateUserSelection('emailByPassPage', topicName);
      }
      if (isPrivacyWebFormEnabledInRC(kanaCode)) {
        return <PrivacyEmailForm />;
      }

      if (kanaCode === kanaCodes.PAYPAL_ME) {
        return <AupViolationEmailForm />;
      }

      return (
        <div className="email-no-intent">
          {this.renderEmailHeader()}
          {this.renderTryAgainLink()}
          <EmailForm />
        </div>
      );
    }
    return null;
  }
}

// EmailNoIntent PropTypes
EmailNoIntent.propTypes = {
  topicTree: PropTypes.arrayOf(PropTypes.shape(TOPICTREE)),
  topicSelection: PropTypes.shape(TOPICTREE), // eslint-disable-line react/no-unused-prop-types
  fetchFormElementsNoIntent: PropTypes.func.isRequired,
  selectTopicResult: PropTypes.func.isRequired,
  emailIntentSelected: PropTypes.func.isRequired,
  error: PropTypes.bool,
  display: PropTypes.bool,
  isLogoutForm: PropTypes.bool,
  updateUserSelection: PropTypes.func.isRequired,
  kanaCode: PropTypes.string.isRequired,
  isIdiLoading: PropTypes.bool.isRequired,
  isIdiServiceLoaded: PropTypes.bool.isRequired,
  topicName: PropTypes.string.isRequired,
  fieldPrefix: PropTypes.string.isRequired,
  retryCount: PropTypes.number,
};

EmailNoIntent.defaultProps = {
  topicTree: [],
  topicSelection: undefined,
  error: false,
  display: false,
  isLogoutForm: false,
};

function mapStateToProps(state) {
  const topicTree = [];
  topicTree.push(state.topicTree.topicTreeSelection);
  return {
    topicTree,
    topicSelection: state.topicTree.topicTreeSelection,
    error: state.topicTree.error,
    display: state.topicTree.display,
    isLogoutForm: state.emailNoIntent.isLogoutForm,
    kanaCode: state.emailNoIntent.kanaCode,
    isIdiLoading: state.contactChannels.isIdiLoading,
    isIdiServiceLoaded: state.contactChannels.isIdiServiceLoaded,
    topicName: state.emailNoIntent.topicName,
    fieldPrefix: state.emailNoIntent.fieldPrefix,
    retryCount: state.emailNoIntent.retryCount,
  };
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      fetchFormElementsNoIntent,
      selectTopicResult,
      emailIntentSelected,
      updateUserSelection,
    },
    dispatch,
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(EmailNoIntent);
